export default __webpack_public_path__ + "static/media/right_arrow.0141c2f5.svg";